// extracted by mini-css-extract-plugin
export default {"featuresContainer":"hotelCardFeatures-module__featuresContainer__ScJiX"};